// Ekran TV: nazwisko przed imieniem. API ma jedno pole runners.name (dowolny tekst organizatora),
// więc zgadujemy: ostatni wyraz to nazwisko („Anna Maria Kowalska” → „Kowalska Anna Maria”).
// Kto wpisuje „Nazwisko Imię” albo nazwy drużyn, wyłącza to w linku: nazwisko=0.

function isUpperWord(word) {
  return word.length > 1 && word === word.toLocaleUpperCase('pl') && word !== word.toLocaleLowerCase('pl')
}

/**
 * @returns {{ lead: string, rest: string }} lead = pogrubiona część (nazwisko), rest = reszta (imię)
 */
export function nameParts(name, surnameFirst = true) {
  const full = String(name || '').trim().replace(/\s+/g, ' ')
  const words = full ? full.split(' ') : []
  if (!surnameFirst || words.length < 2) return { lead: full, rest: '' }
  const last = words[words.length - 1]
  // „KOWALSKI Jan” — nazwisko już jest pierwsze (wielkimi literami)
  if (isUpperWord(words[0]) && !isUpperWord(last)) return { lead: words[0], rest: words.slice(1).join(' ') }
  // na końcu klub, numer albo dopisek w nawiasie — nie zgadujemy
  if (/[\d()[\]/]/.test(last)) return { lead: full, rest: '' }
  return { lead: last, rest: words.slice(0, -1).join(' ') }
}
